import { ContentControlledEventActionEnum } from '../enums';
import { ContentControlledEditingDirective } from '../editing-directive';
import { ContentControlledKeyframe } from '../keyframe';
import { ContentControlledReportableEvent } from '../reportable-event';
import ContentControlStudioOperation from "./content-control-studio-operation";

export default class ContentControlStudioRevertEventOperation extends ContentControlStudioOperation {
  constructor(
    public event: ContentControlledEditingDirective,
    public re: ContentControlledReportableEvent,
    public reTitle: string,
    public eTitle: string,
    public eventAction: ContentControlledEventActionEnum,
    public eventKeyframes: Array<ContentControlledKeyframe>,
    callback?,
  ) {
    super(
      () => {
        if (event && re) {
          event.keyframes = [...re.keyframes];
          event.isMitigated = false;
          event.title = reTitle;
          event.action = ContentControlledEventActionEnum.Empty;
        }
      },
      () => {
        if (event) {
          event.keyframes = eventKeyframes;
          event.isMitigated = true;
          event.action = eventAction;
          event.title = eTitle;
        }
      },
      callback,
    );
  }
}
